import React, { useState, useEffect } from 'react';
import { Layout, Card, Form, Input, Button } from 'antd';
import { toast } from 'react-toastify';
import languages from '../../constants/languages';
import { getDetailContact, createContact, updateContact } from '../../services/user';

const defaultForm = {name: '', email: ''};

export const ContactForm = props => {
    const [id, setId] = useState(null);
    const [fields, setFields] = useState(null);
    useEffect(() => {
        if(props.match && props.match.params && props.match.params.id){
            setId(props.match.params.id);
            getDetailContact(props.match.params.id).then(res => {
                if(res.status === 1){
                    setFields({
                        ...res.data
                    });
                } else {
                    toast.error(res.message);
                }
            });
        } else {
            setFields(defaultForm);
        }
        // component unmount
        return () => {
            setFields(null);
        };
    },[props.match.params.id]);

    const onFinish = values => {
        if(id){
            onUpdateContact(values);
        } else {
            onCreateContact(values);
        }
    };
    const onCreateContact = values => {
        createContact(values).then(res => {
            if(res.status === 1){
                toast.success(languages.createContactSuccess);
                props.history.push(`${process.env.PUBLIC_URL}/contact/list`);
            } else {
                toast.error(<>{
                    res.message.map((mes, index) => {
                        return <p key={index}>{mes.msg}</p>;
                    })                
                }</>);
            }            
        });
    };

    const onUpdateContact = values => {
        updateContact(id, values).then(res => {
            if(res.status === 1){
                toast.success(languages.updateContactSuccess);
                props.history.push(`${process.env.PUBLIC_URL}/contact/list`);
            } else {
                toast.error(<>{
                    res.message.map((mes, index) => {
                        return <p key={index}>{mes.msg}</p>;
                    })                
                }</>);
            }            
        });
    };

    const onClickCancel = () => {
        props.history.push(`${process.env.PUBLIC_URL}/contact/list`);
    };

    if(!fields){
        return <div>Loading...</div>
    }

    return (
        <Layout className="layout-server flex-1">
            <Card
                title={languages.titleCreateContact}
                className="flex-1"
            > 
                <Form
                    layout={'vertical'}
                    onFinish={onFinish}
                    initialValues={fields}
                >
                    <Form.Item 
                        name="name" 
                        label={languages.formContactName}
                        wrapperCol={{span: 7}}
                        label={<div>{languages.formContactName}<span className="required-field">(必須)</span></div>}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item 
                        name="email" 
                        wrapperCol={{span: 7}}
                        label={<div>{languages.formContactEmail}<span className="required-field">(必須)</span></div>}
                    >
                        <Input placeholder="yourname@yourdomain.com" />
                    </Form.Item>    
                    <Button type="primary" className="mr10 btn-success" htmlType="submit">{languages.btnSaveContact}</Button>    
                    <Button onClick={onClickCancel}>キャンセル</Button>                                       
                </Form>
            </Card>
        </Layout>        
    );
};